import _ from 'underscore';

/**
 * Helper functions to manage state for reflux stores that use PureJS instead of immutable.
 * This is the new version of BaseMixin. Use this instead of BaseMixin when using Pure JS.
 *
 * How to use in store:
 *
 * Reflux.createStore({
 *
 *   ...storeStateHelper //ES6 spread operator
 *
 * })
 *
 */

export default {
  getInitialState() {
    return this.getState();
  },

  getState() {
    return this._state;
  },

  getInState(path) {
    const state = this.getState();
    return state[path];
  },

  setState(state) {
    this._state = state;
    return this._state;
  },

  setStateAndTrigger(state) {
    this._trigger(this.setState(state));
  },

  setInState(key, val) {
    const state = this.getState();

    state[key] = val;

    return this.setState(state);
  },

  setInStateAndTrigger(key, val) {
    const state = this.getState();

    state[key] = val;

    this.setStateAndTrigger(state);
  },

  deleteInState(key) {
    const state = this.getState();

    delete state[key];

    return this.setState(state);
  },

  deleteInStateAndTrigger(key) {
    const state = this.getState();

    delete state[key];

    return this.setStateAndTrigger(state);
  },

  mergeState(obj) {
    const state = this.getState();
    return this.setState(_.extend(state, obj));
  },

  mergeStateAndTrigger(obj) {
    const state = this.getState();
    this.setStateAndTrigger(_.extend(state, obj));
  },

  _trigger() {
    this.trigger(this.getState());
  },

  forceUpdate() {
    this._trigger();
  },
};
